import './LoadingSpinner.css'

const LoadingSpinner = () => {
    return <div className="spinner">
        <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>

}

export default LoadingSpinner